import React, { useState } from "react";
import styled from "@emotion/styled";

import {
  Typography as MuiTypography,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
} from "@mui/material";
import { spacing, SpacingProps } from "@mui/system";

import { useTranslation } from "react-i18next";

import { Folder as FolderIcon } from "@mui/icons-material";
import useAuth from "../../../hooks/useAuth";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { IFolder } from "../../../types/folder";

interface TypographyProps extends SpacingProps {
  component?: string;
}
const Typography = styled(MuiTypography)<TypographyProps>(spacing);

const Title = styled(Typography)`
  color: ${(props) => props.theme.palette.text.secondary};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(7)} ${(props) => props.theme.spacing(1)};
  opacity: 0.8;
  text-transform: uppercase;
  display: block;
`;

interface IFolderAsListItemProps {
  folder: IFolder;
  showMenuIcon?: boolean;
  onMouseEnter?: () => void;
}

const FolderAsListItem = (props: IFolderAsListItemProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const { folder } = props;

  const users = useSelector((state: RootState) => state.users.users);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <ListItem
      onMouseEnter={props.onMouseEnter}
      // secondaryAction={
      //   <>
      //     <IconButton
      //       aria-label="more"
      //       id={`folder-menubutton-${folder.id}`}
      //       aria-controls={open ? `folder-menu-${folder.id}` : undefined}
      //       aria-expanded={open ? "true" : undefined}
      //       aria-haspopup="true"
      //       onClick={handleClick}
      //       sx={{ visibility: props.showMenuIcon ? "visible" : "hidden" }}
      //     >
      //       <MoreVertIcon />
      //     </IconButton>
      //     <StyledMenu
      //       id={`folder-menu-${folder.id}`}
      //       MenuListProps={{
      //         "aria-labelledby": `folder-menubutton-${folder.id}`,
      //       }}
      //       anchorEl={anchorEl}
      //       open={open}
      //       onClose={handleClose}
      //     >
      //       {/* <Divider sx={{ my: 0.5 }} /> */}

      //       {/* <FolderDialog
      //         mode={DialogMode.Edit}
      //         type={note.reminderDate ? "reminder" : "note"}
      //         note={props.note}
      //         asMenuItem
      //       /> */}

      //       {/* <NoteDialog
      //         mode={DialogMode.Delete}
      //         type={note.reminderDate ? "reminder" : "note"}
      //         note={props.note}
      //         asMenuItem
      //       /> */}
      //     </StyledMenu>
      //   </>
      // }
    >
      <ListItemAvatar>
        <Avatar>
          <FolderIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={folder.name} secondary={null} />
    </ListItem>
  );
};

export default FolderAsListItem;
